import RichText from '../RichText/RichText'

export default function Details (props = {
    className: null,
    summary: null,
    text: null
}) {
    let {
        summary,
        text,
        ...renderProps
    } = props

    const propsSummary = summary

    const propsText = text

    summary = null

    text = null

    const isChildren = (props.children || []).length

    if (isChildren
            && props.children[0].type === 'summary') {
        summary = props.children[0]
        text = props.children.slice(1).length
            ? props.children.slice(1)
            : null
    }

    if (isChildren
            && props.children[0].type !== 'summary')
        text = props.children

    if (!summary
            && propsSummary)
        summary = <summary>{propsSummary}</summary>

    if (!text
            && propsText)
        text = <RichText html={propsText} />

    if (!summary || !text)
        return null

    return (
        <details {...renderProps}>
            {summary}
            {text}
        </details>
    )
}
